// import { useContext } from "react";
// import { createContext } from "react";
import { useSelector } from "react-redux";


// const privilagesContext = createContext();
// export const useAuth = () => {
//   console.log(privilagesContext,"privilagesContextprivilagesContextprivilagesContext");
  
//   const context = useContext(privilagesContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// }; 

export const CommonPrivFilter = (moduleId) => {
  const {privileges,userType}=useSelector((state)=>state.privilageSlice)

  

  const filteredObj = privileges?.find((dat) => dat?.unique_id === moduleId);

  return {
    canRead: filteredObj?.read === 1,
    canCreate: filteredObj?.create === 1,
    canUpdate: filteredObj?.update === 1,
    canDelete: filteredObj?.delete === 1,
    canPrint: filteredObj?.print === 1,
    canAttach: filteredObj?.attach === 1
  };
};
//  export default privilagesContext